import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {selectMois, selectSemaineIndex} from "../actions/navigation";
import {connect} from "react-redux";
import {allMois, allSemaines} from "../data/Calendrier";
import {groupBy} from "../utils/array";

class MenuCalendrier extends Component {

  moisLibelle() {
    let mois = allMois.find(v => v.code === allSemaines[this.props.semaineIndex].codeMois);
    return mois.libelle + ' ' + mois.annee;
  }

  render() {

    const groups =  groupBy(allMois, 'annee');
    const items = Object.keys(groups).map(annee => {
        const anneeEntry = <Menu.Item color='red' header active content={annee}/>;
        return [
            anneeEntry,
            ...(groups[annee].map(m => <Menu.Item
                    content={m.libelle}
                    key={m.code}
                    active={this.props.mois.code === m.code}
                    onClick={() => this.props.selectMois(m)}
                    color={'teal'}
                />)
            )
        ];
    });

    if (this.props.byMois) {
      return <Menu pagination>{items}</Menu>;
    } else {
      return (
          <Menu pagination>
            <Menu.Item content='<<' key='sMin' onClick={() => this.props.selectSemaineIndex(0)} />
            <Menu.Item content='<' key='sMinus' onClick={() => this.props.selectSemaineIndex(this.props.semaineIndex - 1)} />
            <Menu.Item content={this.moisLibelle()} key='mois' color={'teal'} active />
            <Menu.Item content='>' key='sPlus' onClick={() => this.props.selectSemaineIndex(this.props.semaineIndex + 1)} />
            <Menu.Item content='>>' key='sMax' onClick={() => this.props.selectSemaineIndex(allSemaines.length - 5)} />
          </Menu>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  byMois: state.navigation.byMois,
  mois: state.navigation.mois,
  semaineIndex: state.navigation.semaineIndex
});

const mapDispatchToProps = (dispatch) => ({
  selectMois: mois => dispatch(selectMois(mois)),
  selectSemaineIndex: semaineIndex => (dispatch(selectSemaineIndex(semaineIndex)))
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuCalendrier);
